<div class="drawer-wrap">
  <ng-content />
</div>
